import { useState, useEffect } from "react";
import { useAppContext } from 'lib/state/TextProvider';
import * as FaIcons from "react-icons/fa";
import { UserLogo } from 'lib/models';
import { useNavigate } from 'react-router-dom';


const UserSelectedLogo = () => {
  const { state } = useAppContext();
  const [userLogo, setUserLogo] = useState(state.userProfile?.userLogo || "FaMoon");
  const SelectedLogo = (FaIcons as Record<UserLogo, React.FC<{onClick?: () => void; className?: string}>>)[userLogo];

  const navigate = useNavigate();

  const logoOnClick = () => {
    navigate(`/`, {replace: true});
  };

  useEffect(() => {
    if (state.userProfile?.userLogo) {
      setUserLogo(state.userProfile?.userLogo);
    }
  }, [state.userProfile, state.userProfile?.userLogo])

  return (
    <div className="flex flex-col space-y-2 items-center">
      <SelectedLogo
         className="w-14 h-14 text-palette-2"
         onClick={logoOnClick}
      />
    </div>
  );
};

export default UserSelectedLogo;
